import { createSlice } from '@reduxjs/toolkit';

interface AudioInitial {
    totalDuration: number
    isPlaying: boolean
    postId: string
    currentTime: number
    volume: number
    speed: number
    isMuted: boolean
    isHidden: boolean
    isAutoScroll: boolean
    projectId: string
    playlistIds: string[]
}

const initialState: AudioInitial = {
    postId: '',
    totalDuration: 0,
    isPlaying: false,
    volume: 100,
    currentTime: 0,
    speed: 0,
    isMuted: false,
    isAutoScroll: true,
    isHidden: true,
    projectId: '',
    playlistIds: []
}

const getStorageAudioState = () => {

    // const audioStorageState = localStorage.getItem('audioState');
    // if (audioStorageState) {
    //     const parsedAudioStorageState = JSON.parse(audioStorageState);

    //     if (parsedAudioStorageState) {
    //         return {...initialState, ...parsedAudioStorageState};
    //     }
    // }

    return {...initialState};
}

const saveStorageAudioState = (state: AudioInitial, payload: any) => {

    const { isPlaying, isHidden, ...stateWithoutIsPlaying } = state;
    // localStorage.setItem('audioState', JSON.stringify({...stateWithoutIsPlaying, ...payload}));
}

export const AudioSlice = createSlice({
    name: 'audio',
    initialState: getStorageAudioState(),
    reducers: {
        setAudioTotalDuration: (state, action) => {
            state.totalDuration = action.payload
            saveStorageAudioState(state, {totalDuration: action.payload});
        },
        setAudioIsPlaying: (state, action) => {
            state.isPlaying = action.payload
        },
        setAudioCurrentTime: (state, action) => {
            state.currentTime = action.payload
            saveStorageAudioState(state, {currentTime: action.payload});
        },
        setAudioVolume: (state, action) => {
            state.volume = action.payload
            saveStorageAudioState(state, {volume: action.payload});
        },
        setAudioSpeed: (state, action) => {
            state.speed = action.payload
            saveStorageAudioState(state, {speed: action.payload});
        },
        setAudioIsMuted: (state, action) => {
            state.isMuted = action.payload
            saveStorageAudioState(state, {isMuted: action.payload});
        },
        setAudioPostId: (state, action) => {
            state.postId = action.payload
            saveStorageAudioState(state, {postId: action.payload});
        },
        setAudioIsHidden: (state, action) => {
            state.isHidden = action.payload
        },
        setAudioIsAutoScroll: (state, action) => {
            state.isAutoScroll = action.payload
        },
        setAudioProjectId: (state, action) => {
            state.projectId = action.payload
        },
        setAudioPlaylistIds: (state, action) => {
            state.playlistIds = action.payload
        },
        clearTrackInfo: (state) => {
            state.postId = '';
            state.projectId = '';
            state.isPlaying = false;
            state.currentTime = 0;
            state.totalDuration = 0;

            saveStorageAudioState(state, {postId: '', projectId: '', currentTime: 0, totalDuration: 0});
        },
        clearAudio: (state) => {
            state.totalDuration = 0;
            state.isPlaying = false;
            state.currentTime = 0;
            state.volume = 100;
            state.speed = 0;
            state.isMuted = false
            state.isHidden = true
            state.postId = ''
            state.projectId = ''
            state.playlistIds = []

            localStorage.removeItem('audioState');
        },
    },
});

export default AudioSlice

export const {
    setAudioTotalDuration,
    setAudioIsPlaying,
    setAudioCurrentTime,
    setAudioVolume,
    setAudioSpeed,
    setAudioIsMuted,
    setAudioIsAutoScroll,
    setAudioIsHidden,
    setAudioPostId,
    setAudioProjectId,
    setAudioPlaylistIds,
    clearTrackInfo,
    clearAudio
} = AudioSlice.actions

export const selectorAudioCurrentTime = (state: any): number => state.audio.currentTime
export const selectorAudioTotalTime = (state: any): number => state.audio.totalDuration
export const selectorAudioIsPlaying = (state: any): string => state.audio.isPlaying
export const selectorAudioVolume = (state: any): number => state.audio.volume
export const selectorAudioSpeed = (state: any): number => state.audio.speed
export const selectorAudioIsMuted = (state: any): boolean => state.audio.isMuted
export const selectorAudioIsAutoScroll = (state: any): boolean => state.audio.isAutoScroll
export const selectorAudioIsHidden = (state: any): boolean => state.audio.isHidden
export const selectorAudioPostId = (state: any): string => state.audio.postId
export const selectorAudioProjectId = (state: any): string => state.audio.projectId
export const selectorAudioPlaylistIds = (state: any): string[] => state.audio.playlistIdsimport { createSlice } from '@reduxjs/toolkit';

interface AudioInitial {
    totalDuration: number
    isPlaying: boolean
    postId: string
    currentTime: number
    volume: number
    speed: number
    isMuted: boolean
    isHidden: boolean
    isAutoScroll: boolean
    projectId: string
    playlistIds: string[]
}

const initialState: AudioInitial = {
    postId: '',
    totalDuration: 0,
    isPlaying: false,
    volume: 100,
    currentTime: 0,
    speed: 0,
    isMuted: false,
    isAutoScroll: true,
    isHidden: true,
    projectId: '',
    playlistIds: []
}

const getStorageAudioState = () => {

    // const audioStorageState = localStorage.getItem('audioState');
    // if (audioStorageState) {
    //     const parsedAudioStorageState = JSON.parse(audioStorageState);

    //     if (parsedAudioStorageState) {
    //         return {...initialState, ...parsedAudioStorageState};
    //     }
    // }

    return {...initialState};
}

const saveStorageAudioState = (state: AudioInitial, payload: any) => {

    const { isPlaying, isHidden, ...stateWithoutIsPlaying } = state;
    // localStorage.setItem('audioState', JSON.stringify({...stateWithoutIsPlaying, ...payload}));
}

export const AudioSlice = createSlice({
    name: 'audio',
    initialState: getStorageAudioState(),
    reducers: {
        setAudioTotalDuration: (state, action) => {
            state.totalDuration = action.payload
            saveStorageAudioState(state, {totalDuration: action.payload});
        },
        setAudioIsPlaying: (state, action) => {
            state.isPlaying = action.payload
        },
        setAudioCurrentTime: (state, action) => {
            state.currentTime = action.payload
            saveStorageAudioState(state, {currentTime: action.payload});
        },
        setAudioVolume: (state, action) => {
            state.volume = action.payload
            saveStorageAudioState(state, {volume: action.payload});
        },
        setAudioSpeed: (state, action) => {
            state.speed = action.payload
            saveStorageAudioState(state, {speed: action.payload});
        },
        setAudioIsMuted: (state, action) => {
            state.isMuted = action.payload
            saveStorageAudioState(state, {isMuted: action.payload});
        },
        setAudioPostId: (state, action) => {
            state.postId = action.payload
            saveStorageAudioState(state, {postId: action.payload});
        },
        setAudioIsHidden: (state, action) => {
            state.isHidden = action.payload
        },
        setAudioIsAutoScroll: (state, action) => {
            state.isAutoScroll = action.payload
        },
        setAudioProjectId: (state, action) => {
            state.projectId = action.payload
        },
        setAudioPlaylistIds: (state, action) => {
            state.playlistIds = action.payload
        },
        clearTrackInfo: (state) => {
            state.postId = '';
            state.projectId = '';
            state.isPlaying = false;
            state.currentTime = 0;
            state.totalDuration = 0;

            saveStorageAudioState(state, {postId: '', projectId: '', currentTime: 0, totalDuration: 0});
        },
        clearAudio: (state) => {
            state.totalDuration = 0;
            state.isPlaying = false;
            state.currentTime = 0;
            state.volume = 100;
            state.speed = 0;
            state.isMuted = false
            state.isHidden = true
            state.postId = ''
            state.projectId = ''
            state.playlistIds = []

            localStorage.removeItem('audioState');
        },
    },
});

export default AudioSlice

export const {
    setAudioTotalDuration,
    setAudioIsPlaying,
    setAudioCurrentTime,
    setAudioVolume,
    setAudioSpeed,
    setAudioIsMuted,
    setAudioIsAutoScroll,
    setAudioIsHidden,
    setAudioPostId,
    setAudioProjectId,
    setAudioPlaylistIds,
    clearTrackInfo,
    clearAudio
} = AudioSlice.actions

export const selectorAudioCurrentTime = (state: any): number => state.audio.currentTime
export const selectorAudioTotalTime = (state: any): number => state.audio.totalDuration
export const selectorAudioIsPlaying = (state: any): string => state.audio.isPlaying
export const selectorAudioVolume = (state: any): number => state.audio.volume
export const selectorAudioSpeed = (state: any): number => state.audio.speed
export const selectorAudioIsMuted = (state: any): boolean => state.audio.isMuted
export const selectorAudioIsAutoScroll = (state: any): boolean => state.audio.isAutoScroll
export const selectorAudioIsHidden = (state: any): boolean => state.audio.isHidden
export const selectorAudioPostId = (state: any): string => state.audio.postId
export const selectorAudioProjectId = (state: any): string => state.audio.projectId
export const selectorAudioPlaylistIds = (state: any): string[] => state.audio.playlistIds